var _defs, _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1144({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 3.08,
    width: 14,
    height: 9.84,
    rx: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8.32,
    r: 0.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.64,5.3h-4v1a.5.5,0,0,1-.5.5H7.82a.5.5,0,0,1-.5-.5v-1h-4a1,1,0,0,0-1,1v4.5a1,1,0,0,0,1,1h9.28a1,1,0,0,0,1-1V6.3A1,1,0,0,0,12.64,5.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.68,5.3V4.45a.5.5,0,0,0-.5-.5H7.82a.5.5,0,0,0-.5.5V5.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.32,5.3v1a.5.5,0,0,0,.5.5h.36a.5.5,0,0,0,.5-.5v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1144);
export default __webpack_public_path__ + "static/media/Symbolpack_1_144.9366f435afd8e31ab2d04b8d557fc636.svg";
export { ForwardRef as ReactComponent };